import { render } from "./ConfidentialityView.vue?vue&type=template&id=3d0f846c&scoped=true"
import script from "./ConfidentialityView.vue?vue&type=script&lang=js"
export * from "./ConfidentialityView.vue?vue&type=script&lang=js"

import "./ConfidentialityView.vue?vue&type=style&index=0&id=3d0f846c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0f846c"]])

export default __exports__